<template>
  <div class="offcanvas offcanvas-end" tabindex="-1" :id="offcanvas_id" data-bs-backdrop="static" :aria-labelledby="`${offcanvas_id}_label`">
    <div class="offcanvas-header">
      <button class="btn-back" type="button" name="button" data-test="btnCloseOffcanvas" data-bs-dismiss="offcanvas" aria-label="Close" @click="doCancel">
        <IconArrowBack/>
        {{ $t('goBack') }}
      </button>
      <h5 class="offcanvas-title d-block" :id="`${offcanvas_id}_label`">
        {{ $t('plans.update.title') }}
      </h5>
    </div>
    <div class="offcanvas-body">
      <p>{{ $t('plans.update.description', { desiredPlanName: desiredPlan.name }) }}</p>

      <div class="text-center">
        <p>{{ $t('plans.update.currentPlanLabel') }}</p>
        <p class="label label-success">
          {{ $t('plans.cancel.currentPlan', { name: currentPlan.name, count: currentPlan.limit }) }}
        </p>
        <b>
          {{ $t(`plans.update.priceLabel.${currentPlan.interval}`, { value: currentPlan.price }) }}
        </b>
      </div>

      <hr>

      <div class="text-center">
        <p>{{ $t('plans.update.desiredPlanLabel') }}</p>
        <p class="label label-success">
          {{ $t('plans.cancel.currentPlan', { name: desiredPlan.name, count: desiredPlan.limit }) }}
        </p>
        <b>
          {{ $t(`plans.update.priceLabel.${desiredPlan.interval}`, { value: desiredPlan.price }) }}
        </b>
      </div>

      <div class="offcanvas-footer">
        <button type="button" class="btn btn-success" data-bs-dismiss="offcanvas" data-test="btnConfirm" @click="doConfirm">{{ $t('plans.cancel.continue') }}</button>
        <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="offcanvas" data-test="btnClose" @click="doCancel">{{ $t('plans.cancel.close') }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.offcanvas {
  .offcanvas-header,
  .offcanvas-body {
    padding:                            0;
  }

  .offcanvas-header {
    display:                            block;
  }

  .offcanvas-title {
    color:                              var(--Brand-Primary, #1B294A);
    font-size:                          38px;
    font-weight:                        300;
    line-height:                        normal;
    margin:                             26px 0;
  }

  .offcanvas-body {
    p,
    b {
      color:                            var(--Brand-Primary, #1B294A);
      font-size:                        var(--font-size-14);
      font-weight:                      300;
      line-height:                      140%; /* 19.6px */
      margin-bottom:                    10px;
    }

    .label-success {
      font-weight:                      600;
      text-transform:                   none !important;
      line-height:                      normal;
      padding:                          10px 15px;
      margin:                           0;
    }

    b {
      font-weight:                      700;
      display:                          block;
      margin-top:                       15px;
      margin-bottom:                    26px;
    }

    .text-center {
      p:first-child {
        font-size:                      var(--font-size-16);
        font-weight:                    600;
      }
    }

    hr {
      border-color:                     var(--Shades-40);
    }
  }

  .offcanvas-footer {
    display:                            flex;
    flex-direction:                     column;
    gap:                                26px;

    .btn {
      font-size:                        var(--font-size-14);
      font-weight:                      700;
      line-height:                      normal;
      letter-spacing:                   4.2px;
      text-align:                       center;
      text-transform:                   uppercase;
      width:                            100%;
      padding:                          20px;
    }

    .btn-success {
      color:                            var(--Shades-W, #FFF);
    }
  }
}
</style>

<script>
import { inject } from "vue";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY);

export default {
  name: 'PlansUpdateOffcanvas',
  props: ['offcanvas_id'],
  data: () => ({
    offcanvas_update: null,
    currentPlan: {
      name: '',
      limit: '',
      price: '',
      interval: '',
    },
    desiredPlan: {
      name: '',
      limit: '',
      price: '',
      interval: '',
    },
    resolvePromise: null,
    rejectPromise: null,
  }),
  mounted() {
  },
  methods: {
    show(options = {}) {
      this.currentPlan.name = options.current?.name || '---';
      this.currentPlan.limit = options.current?.limit || '0';
      this.currentPlan.price = options.current?.price || '0,00';
      this.currentPlan.interval = options.current?.interval || 'month';

      this.desiredPlan.name = options.desired?.name || '---';
      this.desiredPlan.limit = options.desired?.limit || '0';
      this.desiredPlan.price = options.desired?.price || '0,00';
      this.desiredPlan.interval = options.desired?.interval || 'month';

      this.offcanvas_update = new bootstrap.Offcanvas(document.getElementById(this.offcanvas_id)).show()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },

    doConfirm() {
      this.offcanvas_update = null
      this.resolvePromise(true)
    },

    doCancel() {
      this.offcanvas_update = null
      this.resolvePromise(false)
    },
  }
}
</script>
